<template>
    <div>
        <!-- <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <p class="heading is-size-3">INTELLIGENT ADVISOR</p>

                <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false"
                    data-target="navbarBasicExample">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>

            <div id="navbarBasicExample" class="navbar-menu">
                <div class="navbar-start"></div>

                <div class="navbar-end">
                    <div class="navbar-item">
                        <div class="buttons">
                            <a class="button is-primary">
                                <strong>Sign up</strong>
                            </a>
                            <a class="button is-light">
                                Log in
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav> -->
        <section class="section">
            <h1 class="title is-3">
                Your Portfolio
            </h1>
            <h1 class="subtitle is-5">
                Total: {{ totalDollars.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }) }}
            </h1>
        <table class="table is-fullwidth">
            <thead>
                <tr>
                <th><p class="grayText fontSizeHalf">Company/Fund</p></th>
                <th><p class="grayText fontSizeHalf">Ticker</p></th>
                <th><p class="grayText fontSizeHalf">Value</p></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(holding, index) in holdings" :key="index">
                    <td>{{ holding.Name }}</td>
                    <td>{{ holding.Symbol }}</td>
                    <td>{{ holding['Dollars'].toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }) }}</td>
                    <td><a class="tag is-delete is-primary is-light" @click="removeHolding(index)"></a></td>
                </tr>
            </tbody>
        </table>
        <button v-if="holdings.length" class="button is-primary" @click="nextStep">
            <span>Finish and View Checkup</span>
            <span class="icon"><i class="fas fa-arrow-right"></i></span>
        </button>
        </section>
        <section class="section">
            <div class="uploadcontainer">
                <label class="label">Name or Ticker Symbol</label>
                <div class="control has-icons-right">
                    <input autofocus class="search-input input is-medium" type="text"
                        placeholder="E.g. Apple, AAPL, or Vanguard Large Cap Fund" v-model="searchInput"
                        @input="searchCompany" />
                    <span class="icon is-medium is-right">
                        <i class="fas fa-search"></i>
                    </span>
                </div>
                <div class="suggestion-box" v-if="suggestions.length > 0 && searchInput">
                    <ul>
                        <li v-for="(suggestion, index) in suggestions" :key="index"
                            @click="$event => selectSuggestion(suggestion)">
                            {{ suggestion.symbol }} - {{ suggestion.name }}
                        </li>
                    </ul>
                </div>
                <div class="amount field is-grouped">
                    <div class="control">
                        <label class="label">Dollars</label>
                        <Money v-model="Dollars" v-bind="money" class="dollar-input input is-medium"/>
                    </div>
                    <div class="control">
                        <label class="label">Cost Basis (Optional)</label>
                        <Money v-model="CostBasis" v-bind="money" class="dollar-input input is-medium"/>
                        <br>
                        <small><em>Original Purchase Price</em></small>
                    </div>
                </div>
            </div>
            <button class="button is-primary is-focused" @click="addHolding"
                :disabled="!selectedSuggestion || !Dollars">
                <span>Add Holding</span>
                <span class="icon">
                    <i class="fas fa-plus"></i>
                </span>
            </button>
        </section>
    </div>
</template>
<script>
import {Money} from 'v-money'
export default {
    name: "IntelligentAdvisor",
    data() {
        return {
            searchInput: "",
            Dollars: "",
            holdings: [],
            suggestions: [],
            selectedSuggestion: null,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 0,
                masked: false /* doesn't work with directive */
            }
        };
    },
    components: {Money},
    computed: {
        totalDollars() {
            return this.holdings.reduce((total, holding) => total + holding.Dollars, 0);
        },
    },
    methods: {
        selectSuggestion(suggestion) {
            this.selectedSuggestion = suggestion;
            this.searchInput = suggestion.symbol;
            this.suggestions = [];
        },
        async searchCompany() {
            if (this.searchInput.length > 0) {
                try {
                    const response = await fetch(`/ai/company_search?query=${this.searchInput}`
                    );
                    const data = await response.json();
                    this.suggestions = data
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            } else {
                this.suggestions = []
            }
        },
        async addHolding() {
            if (this.selectedSuggestion && this.Dollars) {
                const response = await fetch(`/ai/company_details?query=${this.selectedSuggestion.symbol}`
                )
                console.log('ADD HOLDING RESPONSE')
                let info = await response.json()
                console.log('info here')
                console.log(info)
                info['Dollars'] = this.Dollars
                this.holdings.push(info);
                this.selectedSuggestion = null;
                this.searchInput = "";
                this.Dollars = "";
            }
        },
        removeHolding(index) {
            this.holdings.splice(index, 1);
        },
        nextStep() {
            this.$emit("nextStep", {
                module: 'portfolio',
                holdings: this.holdings
            })
        }
    },
};

</script>
<style scoped>
/* Add your styles here */
body {
    padding: 0.5em;
}
.portfolio-title {
    text-align: left;
    font-weight: bold;
    font-size: 2em; /* Change the value as needed */
  }
.portfolio-amount {
    text-align: right;
    font-weight: bold;
    font-size: 2em; /* Change the value as needed */
  }
.section {
    background-color: inherit;
}

.uploadcontainer {
    max-width: 65rem;
    margin: auto;
}

.suggestion-box {
    background-color: white;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    margin-top: 5px;
    max-height: 200px;
    overflow-y: scroll;
    position: absolute;
    width: 100%;
    z-index: 1000;
  }
  
  .suggestion-box ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  
  .suggestion-box li {
    cursor: pointer;
    padding: 8px 16px;
  }
  
  .suggestion-box li:hover {
    background-color: #f5f5f5;
  }
  .search-input {
    width: 100%;
  }
  .dollar-input {
    width: 60%;
  }
  .amount {
    margin-top: 20px;
  }
</style>
